/* eslint camelcase: 0 */
import initI18n from './i18n';
import Vue from 'vue';
import Vuex from 'vuex';
import store from './store';
import HotelmeisterMixin from '../../mixins/HotelmeisterMixin';
import { cloneDeep, isEmpty, isNil, isString, startsWith } from 'lodash';
import { getToken, clearToken } from './token';
import UpdateHotelSettingsMixin from '../../mixins/UpdateHotelSettingsMixin';

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/de.json'));
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/es.json'));
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'));
countries.registerLocale(require('i18n-iso-countries/langs/it.json'));
countries.registerLocale(require('i18n-iso-countries/langs/fr.json'));

const languages = require('@cospired/i18n-iso-languages');
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/de.json'));
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/en.json'));
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/es.json'));
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/nl.json'));
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/it.json'));
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/fr.json'));

// eslint-disable-next-line import/prefer-default-export
export default function createInstance(component, name, axios, router) {
  const i18n = initI18n();

  return {
    name: 'App',
    i18n: i18n,
    store: new Vuex.Store(store),
    router: router,
    mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin],
    data: {
      app: name,
      i18n: {
        countries: countries,
        languages: languages,
      },
      keepAlive: null,
      hotelmeisterVueKeepAlives: 0,
    },
    render(h) {
      return h(
        'div',
        {
          attrs: {
            id: `app-${name}`,
          },
        },
        [h(component)],
      );
    },
    computed: {
      hmDisabledFields: function () {
        try {
          return this.hotelSettings.details.disabledFields || [];
        } catch (ignore) {
          return [];
        }
      },
      hotel: function () {
        return this.$store.getters['hotel/hotelId'];
      },
      username: function () {
        return this.$store.getters['hotel/username'];
      },
      user: function () {
        return this.$store.getters['hotel/user'];
      },
      tabId: function () {
        return this.$store.getters['hotel/tabId'];
      },
    },
    watch: {
      tabId: function (tabId) {
        sessionStorage.setItem('tabId', tabId);
      },
    },
    created() {
      sessionStorage.setItem('tabId', this.tabId);
      if (!isNil(this.$route.query) && !isNil(this.$route.query.token)) {
        // setToken(this.hotel, this.$route.query.token);
      }
      // setInterval(() => {
      //   serviceBus.$emit('speedtest.silent');
      // }, 60 * 1000 * 30);
      this.keepAlive = setInterval(() => {
        if (!isEmpty(getToken(this.hotel)) && window.vueActive) {
          axios.get('/echo/keepAlive', {
            hotelId: this.hotel,
            headers: {
              'x-hotelsoftware-hotelid': this.hotel,
            },
          })
            .then((response) => {
              if (isEmpty(this.username)) {
                const username = isEmpty(response.headers['x-hotelsoftware-username']) ? null : response.headers['x-hotelsoftware-username'].toLocaleLowerCase();
                this.$store.dispatch('hotel/updateUser', username);
              }
              this.hotelmeisterVueKeepAlives = 0;
            })
            .catch((error) => {
              this.hotelmeisterVueKeepAlives += 1;
              this.addBreadcrumb('Network', `KeepAlive request failed (${this.hotelmeisterVueKeepAlives}/5)`);
              if (error.status === 401 || this.hotelmeisterVueKeepAlives >= 5) {
                this.logout();
              }
            });
        } else {
          this.addBreadcrumb('Network', 'No Security token found - logging out.');
          this.logout();
        }
      }, 54360);
      this.$serviceBus.$on('logout', this.logout);
    },
    mounted() {
      this.$nextTick(function () {
        window.addEventListener('resize', this.updateWindowWidth);
        window.addEventListener('resize', this.updateWindowHeight);

        // Init
        this.updateWindowWidth();
        this.updateWindowHeight();
      });
    },
    methods: {
      hasAnyRole: function (roleNames) {
        if (isNil(this.$root.user)) return false;

        return roleNames.filter(roleName => this.$root.user.roles.includes(roleName)).length > 0;
      },
      hasRole: function (roleName) {
        if (isNil(this.$root.user)) {
          return false;
        } else if (roleName !== 'ROLE_HOTELMEISTER_SUPER_ADMIN' && this.$root.user.roles.includes('ROLE_SYSADMIN')) {
          switch (roleName) {
            case 'ROLE_WEB_AGENCY':
            case 'ROLE_UNIT_OWNER':
            case 'ROLE_UNIT_OWNER_REPORTS':
              return false;
            default:
              return roleName.startsWith('ROLE_');
          }
        } else {
          return this.$root.user.roles.includes(roleName);
        }
      },
      updateHotels() {
        if (isEmpty(this.hotel)) {
          this.$store.commit('hotel/ACCESSIBLE_HOTELS', 0);
        } else {
          this.$store.dispatch('hotel/updateAccessibleHotels');
        }
      },
      logout() {
        // this.$root.hotel = null;
        // this.$root.username = null;
        // this.$root.user = null;
        this.$store.dispatch('hotel/logout');
        if (this.$route.name !== 'login') {
          this.reportError('Logout');
          this.$router.push({ name: 'login' });
        }
      },
      testToken() {
        return axios.get('/echo/keepAlive', {
          hotelId: this.hotel,
          headers: {
            'x-hotelsoftware-hotelid': this.hotel,
          },
        })
          .then((response) => {
            const username = isEmpty(response.headers['x-hotelsoftware-username']) ? null : response.headers['x-hotelsoftware-username'].toLocaleLowerCase();
            this.$store.dispatch('hotel/updateUser', username);
          })
          .catch((error) => {
            this.addUIBreadcrumb('LOGOUT - testing token failed');
            this.logout();
          });
      },
      updateWindowWidth(event) {
        this.$store.commit('layout/windowWidth', document.documentElement.clientWidth);
      },
      updateWindowHeight(event) {
        this.$store.commit('layout/windowHeight', document.documentElement.clientHeight);
      },
      openInNewTab() {
        const newRoute = {
          name: this.$route.name,
          params: cloneDeep(this.$route.params),
          path: this.$route.path,
          query: cloneDeep(this.$route.query),
          meta: cloneDeep(this.$route.meta),
        };
        if (isNil(newRoute.query)) newRoute.query = {};
        newRoute.query.token = getToken(this.hotel);
        const routeURL = this.$router.resolve(newRoute);
        window.open(routeURL.href, '_blank');
      },
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateWindowWidth);
      window.removeEventListener('resize', this.updateWindowHeight);
      clearInterval(this.keepAlive);
      this.$serviceBus.$off('logout', this.logout);
    },
  };
}



// WEBPACK FOOTER //
// ./src/lib/util/instance.js